import React from "react";
import { ArrowRight, CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EmpoweringYourNextBigLeap() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="18751" id="the-strategic-edge" ref={sectionRef} className="relative w-full overflow-hidden bg-background py-16 lg:py-24 xl:py-32 dark">
      {}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-10">
        <div className="absolute -top-24 -left-24 h-96 w-96 rounded-full bg-primary blur-3xl filter" />
        <div className="absolute top-1/2 right-0 h-64 w-64 -translate-y-1/2 rounded-full bg-primary opacity-20 blur-3xl filter" />
      </div>

      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-12 lg:flex-row lg:items-center lg:gap-16">
          
          {}
          <div className={`flex w-full flex-col lg:w-[60%] transition-all duration-1000 ease-out ${isVisible ? "translate-x-0 opacity-100" : "-translate-x-10 opacity-0"}`}>
            <h1 className="font-default text-4xl font-medium leading-tight tracking-tight text-foreground sm:text-5xl lg:text-6xl xl:text-7xl">
              Validate, build, and{" "}
              <span className="bg-gradient-to-r from-foreground to-primary bg-clip-text text-transparent">
                scale
              </span>{" "}
              with the right support behind you.
            </h1>

            <p className="mt-6 max-w-2xl font-default text-lg leading-relaxed tracking-normal text-muted-foreground sm:text-2xl">
              We provide the structural foundations through Branded Basecamp, 
              strategic consulting, and our selective venture studio.
            </p>

            <div className="mt-10 flex flex-wrap gap-4">
              <Button asChild size="lg" className="h-12 rounded-sm bg-primary px-8 text-base text-primary-foreground transition-transform hover:scale-105">
                <Link to="#">
                  Tell Us What You’re Building
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="h-12 rounded-sm border-primary px-8 text-base text-primary hover:bg-primary hover:text-primary-foreground">
                <Link to="#">Explore Branded Basecamp</Link>
              </Button>
            </div>

            <div className="mt-8 flex flex-wrap gap-x-8 gap-y-3 text-sm font-medium text-muted-foreground">
              {["Strategic Advisory", "Operational Growth", "Venture Execution"].map((item, i) => <div key={i} data-index={i} className="flex items-center gap-2">
                    <CircleCheck className="h-4 w-4 text-primary" />
                    <span className="font-default">{item}</span>
                  </div>)}
            </div>
          </div>

          {}
          <div className={`relative mt-12 flex w-full justify-center lg:mt-0 lg:w-[40%] lg:justify-end transition-all duration-1000 delay-300 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            <div className="relative h-[400px] w-full max-w-[500px] sm:h-[500px]">
              
              {}
              <div className="pointer-events-none absolute inset-0 z-20 mix-blend-overlay opacity-30" style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
            }}>
              </div>

              {}
              <div className="absolute top-0 right-0 z-10 h-[75%] w-[70%] overflow-hidden rounded-sm ring-1 ring-white/10">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1622697/img/diverse_startup_team_meeting.png" alt="Architectural abstract composition showing clean lines and shadows" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
              </div>

              {}
              <div className="absolute bottom-0 left-4 z-20 h-[45%] w-[55%] overflow-hidden rounded-sm border-4 border-background">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1622697/img/female_entrepreneur_pitching.png" alt="Minimalist light and shadow geometry" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
              </div>

              {}
              <div className="absolute top-12 left-0 z-0 h-32 w-32 overflow-hidden rounded-full border-4 border-background/50 opacity-40 blur-[1px]">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1622697/img/founder_working_collaboratively.png" alt="Abstract metallic texture" className="h-full w-full object-cover grayscale" />
              </div>

              {}
              <div className="absolute -bottom-6 -right-6 -z-10 h-40 w-40 rounded-full border-2 border-primary opacity-20" />
              <div className="absolute top-1/2 left-1/2 -z-10 h-64 w-64 -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary opacity-5 blur-2xl" />
              
              {}
              <div className="absolute top-[60%] -right-4 z-30 flex items-center gap-2 rounded-sm bg-background/90 p-3 backdrop-blur-sm border border-border">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary/20 text-primary">
                  <CircleCheck className="h-5 w-5" />
                </div>
                <div>
                  <p className="font-default text-xs font-bold text-foreground">Operator Led</p>
                  <p className="font-default text-[10px] text-muted-foreground">Selective Studio</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>;
}